// extracted by mini-css-extract-plugin
module.exports = {"defaulIcon":"infoitem_defaulIcon__3AFcA","valueCol":"infoitem_valueCol__13JrM"};